import React, { useState } from 'react';
import { Box, Stack, TableContainer, Paper } from '@mui/material';
import { RateType } from 'api/consumablesApi';
import { useQuery } from '@tanstack/react-query';
import { listEquipmentItems } from 'api/equipmentApi';
import EquipmentFilterSection from './EquipmentFilterSection';
import AddEquipmentRates from './AddEquipmentRates';
import EquipmentDetailsView from './EquipmentDetailsView';
import { EquipmentRatesTableComponent } from './EquipmentRatesTableComponent';
import AddNewRateCardItemButton from './AddNewRateCardItemButton';
import { useEquipmentFilters } from '../Utils/useEquipmentFilters';
import BulkUpdateRatesDialog, { ImportRateScope } from './BulkUpdateRatesDialog';
import ImportRateCardMenuButton from './ImportRateCardMenuButton';

export default function EquipmentRateCardHomePage({}: {}) {
  const [modalState, setModalState] = useState({
    buyRate: false,
    sellRate: false,
    equipmentDetailsView: false,
  });
  const [selectedItemId, setSelectedItemId] = useState<string | undefined>(
    undefined
  );
  const [importScope, setImportScope] = useState<ImportRateScope | null>(null);

  const openModal = (key: keyof typeof modalState) =>
    setModalState((prev) => ({ ...prev, [key]: true }));

  const closeModal = (key: keyof typeof modalState) =>
    setModalState((prev) => ({ ...prev, [key]: false }));

  const equipmentData = useQuery(['equipment-rate-items'], listEquipmentItems);

  const {
    state: filterState,
    dispatch: filterDispatch,
    activeFilterCount,
    filteredResult: filteredEquipmentData,
    applyFilters,
    resetFilters,
  } = useEquipmentFilters(equipmentData.data, () => {});

  return (
    <Box sx={{ m: 3, backgroundColor: '#fff', borderRadius: 1 }}>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: 'flex-end',
          p: '1rem',
        }}>
        <EquipmentFilterSection
          filterState={filterState}
          filterDispatch={filterDispatch}
          activeFilterCount={activeFilterCount}
          applyFilters={applyFilters}
          resetFilters={resetFilters}
          equipmentData={equipmentData.data}
          isFetching={equipmentData.isFetching}
        />
        <ImportRateCardMenuButton onSelect={setImportScope} />
        <AddNewRateCardItemButton
          onClickAddBuyRate={() => openModal(RateType.BuyRate)}
          onClickAddSellRate={() => openModal(RateType.SellRate)}
        />
      </Stack>
      <TableContainer component={Paper}>
        <Stack
          sx={{
            marginBottom: '1rem',
          }}>
          <EquipmentRatesTableComponent
            equipmentData={
              filteredEquipmentData ? filteredEquipmentData : equipmentData.data
            }
            handleDetailsViewOpen={() => openModal('equipmentDetailsView')}
            setSelectedItemId={setSelectedItemId}
          />
        </Stack>
      </TableContainer>
      <AddEquipmentRates
        handleSellRateFormClose={() => closeModal(RateType.SellRate)}
        handleBuyRateFormClose={() => closeModal(RateType.BuyRate)}
        openSellRateForm={modalState.sellRate}
        openBuyRateForm={modalState.buyRate}
      />
      {modalState.equipmentDetailsView && (
        <EquipmentDetailsView
          handleEquipmentClose={() => closeModal('equipmentDetailsView')}
          selectedItemId={selectedItemId}
          open={modalState.equipmentDetailsView}
        />
      )}
      {importScope && (
        <BulkUpdateRatesDialog
          open={true}
          scope={importScope}
          handleClose={() => setImportScope(null)}
        />
      )}
    </Box>
  );
}
